module.exports = __webpack_public_path__ + "img/content-img5_1.dab980e7.png";